import React, { useEffect } from 'react';
//import WebApp from '@twa-dev/sdk';
import { Outlet } from 'react-router-dom';
import TelegramProvider from './TelegramProvider';

//const types = ['service', 'contract', 'product', 'invoice'];

const index = () => {
 useEffect(() => {
  //WebApp.ready();
  window.eruda.init();
 }, []);

 return (
  <TelegramProvider>
   <Outlet />
  </TelegramProvider>
 );
};

export default index;
